export default function processSteps (currentStep, defaultPrevStep = null, defaultNextStep = null) {
  defaultPrevStep = defaultPrevStep || currentStep
  defaultNextStep = defaultNextStep || currentStep
  return {
    props: {
      previousStep: {
        type: String,
        default: defaultPrevStep
      },
      nextStep: {
        type: String,
        default: defaultNextStep
      }
    },
    methods: {
      isCurrentStep (requestedStep) {
        return this.stepName === requestedStep
      }
    },
    computed: {
      stepName () {
        return currentStep
      }
    }
  }
}
